/** 
 * @type {TransactionRequestsFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: [],
    investor_ids: [],
    types: [],
    currency_ids: [],
}
/** 
* @returns {TransactionRequestsFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/TransactionRequestsFilter.js